@if (isTitle) {
    <h1 [class]="class">{{ value }}</h1>
} @else {
    <p [class]="class">{{ value }}</p>
}
